import {useAppDispatch, useAppSelector} from "../../hooks";
import {markNotificationsUnreadAction} from "../../actions/actions";
import React from "react";
import {SupportBar} from "@healthiq/vantage-ui-components";
import {selectResources, selectUser} from "../../actions/userSlice";
import {UserDetails} from "../../actions/api";

export const toSupportBarUser = (user: UserDetails | undefined) => {
    if (user === undefined) {
        return undefined
    }

    return {
        id: user.username,
        accountId: user.company.hash,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.username,
        name: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
        role: user.role.toString(),
        jobTitle: user.jobTitle,
        company: user.company.name
    }
}

export const AppSupportBar = ({transparent, onClickMenu}: {
    transparent?: boolean,
    onClickMenu?: () => void
}) => {
    const user = useAppSelector(selectUser)
    const resources = useAppSelector(selectResources)
    const notifications = useAppSelector(state => state.settings.values.NOTIFICATIONS)
    const dispatch = useAppDispatch()

    return <SupportBar
        user={toSupportBarUser(user)}
        resources={resources?.resources || []}
        notifications={notifications}
        markNotificationsRead={() => dispatch(markNotificationsUnreadAction())}
        transparent={transparent}
        onClickMenu={onClickMenu}
    />
}